<template>
  <router-link v-if="currentHomeCategory && partner" class="back-to-home-category" :to="localizedRoute(routerLink)">
    <span class="material-icons">chevron_left</span>
    {{ $t('Back to catalog') }}
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonBackHomeCategory',
  props: {
    partner: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      singlePartnerCategory: false,
    };
  },
  computed: {
    ...mapGetters({
      getCategoryById: 'partner_categories/getCategoryById',
      getActivePartnersCategory: 'partner_categories/getActivePartnersCategory'
    }),
    currentHomeCategory () {
      return this.getActivePartnersCategory || this.getCategoryById(this.partner.categories[0])
    },
    routerLink () {
      return this.singlePartnerCategory ? `/${this.partner.location_code}` : `/${this.partner.location_code}/${this.currentHomeCategory.code}`
    }
  },
  mounted() {
    this.checkCurrentPartnerCategory()
  },
  methods: {
    checkCurrentPartnerCategory () {
      if (!this.currentHomeCategory) {
        return
      }
      this.$store.dispatch(
        'partners/partnersCount',
        { locationCode: this.partner.location_code, categoryId: this.currentHomeCategory.entity_id }
      ).then(resp => {
        this.singlePartnerCategory = resp.count <= 1;
      }).catch(error => {
        console.error(error)
        this.singlePartnerCategory = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.back-to-home-category {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #000000;
  margin-bottom: 20px;
  margin-left: 10px;
  &:hover {
    color: #7e7171;
  }
}
.back-to-home-category.underline:after, .back-to-home-category:not(.no-underline):hover:after {
  background: none;
}
</style>
